import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'AugmentedReality2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-augmented-reality-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 21h-2a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17l-4 -2.5l4 -2.5l4 2.5v4.5l-4 2.5z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 14.5v4.5l4 2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17l4 -2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 4h2"
    }, null), _createTextVNode(" ")]);
  }
};